export const PAYMENT_FORMS = {
  CREDIT_CARD: 1,
  MONEY: 2,
  PIX: 3,
  REINVESTMENT: 4,
  BANK_SLIP: 5,
  INSTALLMENT_CARD: 6,
  DEPOSIT: 7,
  PIX_MAQUINETA: 5,
  PIX_CNPJ: 8,
  VALE: 9,
  ADVANCE_PAYMENT: 10,
  PIX_BTG: 11,
  MONEY_BLEED: 12, // Dinheiro - Sangria (saldo de sangria do vendedor)
};

export const PAYMENT_ADVANCE_STATUS = {
  PENDING: "pending",
  PAID: "paid",
  USED: "used",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
  CONVERTED: "converted",
};

export const PAYMENT_ADVANCE_STATUS_LABELS = {
  [PAYMENT_ADVANCE_STATUS.PENDING]: "Pendente",
  [PAYMENT_ADVANCE_STATUS.PAID]: "Pago",
  [PAYMENT_ADVANCE_STATUS.USED]: "Utilizado",
  [PAYMENT_ADVANCE_STATUS.CANCELLED]: "Cancelado",
  [PAYMENT_ADVANCE_STATUS.EXPIRED]: "Expirado",
  [PAYMENT_ADVANCE_STATUS.CONVERTED]: "Convertido",
};

export const PAYMENT_STATUS = {
  WAITING: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
  REJECTED: 4,
};

export const SALE_STEPS = {
  WAITING_PAYMENT: 1,
  PAYMENT_APPROVED: 2,
  PAYMENT_REJECTED: 3,
  IN_SEPARATION: 4,
  IN_DELIVERY: 5,
  DELIVERED: 6,
  CANCELED: 7,
};

export const SALE_TYPE_ID = {
  PICKUP: 1,
  ENDOSSO: 2,
  DELIVERY: 3,
  SEDEX: 4,
  CARNE: 5,
  PARTNER_SALE: 6,
};

export const PIX_STATUS = {
  ACTIVE: "ATIVA",
  PAID: "CONCLUIDA",
  COMPLETED: "COMPLETED",
};

export const SALE_STATUS = {
  IN_PROGRESS: 1,
  APPROVED: 2,
  FAILED: 3,
  CANCELED: 4,
  EDITED: 5,
  CANCELLED_WITH_PIX: 6,
  EDITED_AND_APPROVED: 7,
};

export const SALE_STATUS_LABELS = {
  [SALE_STATUS.IN_PROGRESS]: "Em Progresso",
  [SALE_STATUS.APPROVED]: "Aprovado",
  [SALE_STATUS.CANCELED]: "Cancelado",
  [SALE_STATUS.EDITED]: "Editado",
  [SALE_STATUS.EDITED_AND_APPROVED]: "Editado e Aprovado",
  [SALE_STATUS.CANCELLED_WITH_PIX]: "Cancelada com pix",
};
